<template>
  <!-- Edit Profile Data -->
  <section class="section  section--profile">
    <div class="container-lg">
      <form action="/" class="form" method="post" @submit.prevent="submitForm">
        <div class="row">
          <div class="col-lg-9">
            <div class="section__header">
              <h2 class="section__title">{{ in18['page_edit_profile_data'] }}</h2>
              <div class="section__text">
                {{ in18['page_edit_profile_permission_msg'] }}
              </div>
            </div>

            <div class="form__fieldset">
              <div class="row">

                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input id="user_name"
                           v-model="user.name"
                           class="form-control"
                           name="user_name"
                           type="text"
                    >
                    <label class="form-label" for="user_name">
                      {{ in18['attribute_user_name'] }}
                      <validation-error :errors="errors['user.name']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-user"></use>
                    </svg>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input id="user_surname"
                           v-model="user.surname"
                           class="form-control"
                           name="user_surname"
                           type="text"
                    >
                    <label class="form-label" for="user_surname">
                      {{ in18['attribute_user_surname'] }}
                      <validation-error :errors="errors['user.surname']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-user"></use>
                    </svg>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input id="user_email"
                           v-model="user.email"
                           class="form-control"
                           name="user_email"
                           type="email"
                           disabled
                           readonly
                    >
                    <label class="form-label" for="user_email">
                      {{ in18['attribute_user_email'] }}
                      <validation-error :errors="errors['user.email']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-email"></use>
                    </svg>
                  </div>
                </div>

                <div class="col-lg-6">
                  <TelFormField
                      v-model="user.phone"
                      icon="form-phone"
                      name="mobile_phone_number"
                      :id="'mobile_phone_number'"
                      :label="in18['attribute_user_phone']"
                      :errors="phoneErrors"/>
                </div>

                <template v-if="user.type === 'b2b'">

                  <div v-if="user.company.bank" class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_bank"
                             v-model="user.company.bank.name"
                             class="form-control"
                             name="company_bank"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_bank">
                        {{ in18['attribute_user_phone'] }}
                        <validation-error :errors="errors['user.phone']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-bank"></use>
                      </svg>
                    </div>
                  </div>

                  <div v-if="user.company.acc_num" class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_acc_num"
                             v-model="user.company.acc_num"
                             class="form-control"
                             name="company_acc_num"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_acc_num">
                        {{ in18['attribute_company_account_number'] }}
                        <validation-error :errors="errors['user.company.acc_num']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-card"></use>
                      </svg>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_name"
                             v-model="user.company.name"
                             class="form-control"
                             name="company_name"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_name">
                        {{ in18['attribute_company_name'] }}
                        <validation-error :errors="errors['user.company.name']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_reg_num"
                             v-model="user.company.reg_num"
                             class="form-control"
                             name="company_reg_num"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_reg_num">
                        {{ in18['attribute_company_reg_number'] }}
                        <validation-error :errors="errors['user.company.reg_number']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_vat_num"
                             v-model="user.company.vat_num"
                             class="form-control"
                             name="company_vat_num"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_vat_num">
                        {{ in18['attribute_company_tax_number'] }}
                        <validation-error :errors="errors['user.company.tax_number']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input id="company_address"
                             v-model="user.company.address"
                             class="form-control"
                             name="company_address"
                             type="text"
                             disabled
                             readonly
                      >
                      <label class="form-label" for="company_address">
                        {{ in18['attribute_company_address'] }}
                        <validation-error :errors="errors['user.company.address']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                </template>

                <!-- Add a div to contain the password fields, conditionally rendering it -->
                <template v-if="showChangePasswordForm">
                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="new_password"
                             v-model="user.new_password"
                             class="form-control"
                             name="new_password"
                             type="password"
                             autocomplete="new-password"
                      >
                      <label class="form-label" for="new_password">
                        {{ in18['attribute_password_new_password'] }}
                        <validation-error :errors="errors['user.new_password']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-lock"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="new_password_confirmation"
                             v-model="user.new_password_confirmation"
                             :disabled="inProgress"
                             class="form-control"
                             name="new_password_confirmation"
                             type="password"
                             autocomplete="new-password"
                      >
                      <label class="form-label" for="new_password_confirmation">
                        {{ in18['attribute_password_confirm_password'] }}
                        <validation-error :errors="errors['user.new_password_confirmation']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-lock"></use>
                      </svg>
                    </div>
                  </div>
                </template>

                <div class="col-lg-6">
                  <google-recaptcha-v3
                      id="profile_action"
                      ref="captcha"
                      v-model="user.gRecaptchaResponse"
                      :site-key="captcha_site_key"
                      action="profile_action"
                      corner
                  ></google-recaptcha-v3>
                </div>
              </div><!-- /.row -->

              <ul class="actions-list  actions-list--end">
                <li class="actions-list__item">
                  <a :title="togglePasswordText" class="link  link--gray" href="#"
                     @click.prevent="togglePasswordFields">
                    {{ togglePasswordText }}
                  </a>
                </li>
              </ul>
            </div><!-- /.form__fieldset -->
            <button :disabled="inProgress" class="btn  btn--md  btn--red" type="submit">
              {{ in18['page_save'] }}
            </button>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </form>
    </div><!-- /.container -->
  </section>
</template>

<script>

import ValidationError from './../../features/ValidationError.vue';
import GoogleReCaptchaV3 from './../../features/GoogleReCaptchaV3.vue';
import TelFormField from '../form-field/TelFormField.vue'

export default {
  name:       "ProfileDetails",
  components: {
    ValidationError,
    GoogleReCaptchaV3,
    TelFormField,
  },
  props:      {
    user:             {
      type: Object
    },
    banks:            {
      type: Object
    },
    in18:             {
      type: Object
    },
    captcha_site_key: {
      type: String
    }
  },
  computed:   {
    togglePasswordText() {
      return this.showChangePasswordForm
          ? this.in18['page_change_password_off']
          : this.in18['page_change_password'];
    },
    phoneErrors() {
      let errors = []
      if (this.errors['user.phone.number']) {
        errors = errors.concat(this.errors['user.phone.number'])
      }
      if (this.errors['user.phone.countryCallingCode']) {
        errors = errors.concat(this.errors['user.phone.countryCallingCode'])
      }
      return errors
    }
  },
  data() {
    return {
      inProgress:             false,
      errors:                 [],
      showChangePasswordForm: false,
    }
  },
  methods: {

    togglePasswordFields() {
      this.showChangePasswordForm = !this.showChangePasswordForm;
    },

    submitForm() {

      if (this.inProgress) {
        return;
      }

      this.inProgress = true;

      axios.post('/api/user/update', {user: this.user})
          .then((response) => {
            this.errors = [];
            window.toastr.success(response.data.message);
            this.user = response.data.user;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.inProgress = false;
            this.$refs.captcha.execute();
            window.scrollToErrorMessage()
          });
    }
  },
};
</script>
